// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./tips-options-bg.jpg");
var dir = previousRequest.replace("tips-options-bg.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "tips-options-bg.jpg",
	name: "tips-options-bg",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/tips-options-bg.jpg
// module id = 1024
// module chunks = 4